import {PoliciesController} from './policies.controller';
import {PolicyFormController} from './policy_form.controller';

function policiesConfig($stateProvider) {
    $stateProvider
        .state('policies', {
            url: '/policies',
            parent: 'app-layout',
            template: require('./policies.html'),
            controller: 'PoliciesController as Policies',
            params: {
                title: 'Policies'
            }
        })
        .state('policies.new', {
            url: '/policies/new',
            parent: 'app-layout',
            template: require('./policy_form.html'),
            controller: 'PolicyFormController as PolicyForm',
            params: {
                title: 'Add Policy'
            }
        })
        .state('policies.edit', {
            url: '/policies/{policyName}/edit',
            parent: 'app-layout',
            template: require('./policy_form.html'),
            controller: 'PolicyFormController as PolicyForm',
            params: {
                title: 'Edit Policy'
            }
        });
}

export default angular.module('policies', [])
    .config(policiesConfig)
    .controller('PoliciesController', PoliciesController)
    .controller('PolicyFormController', PolicyFormController);



// WEBPACK FOOTER //
// ./modules/xray/states/policies/policies.module.js